﻿import API from '../api/apiUtils/api2';
import { ExtHubRequest } from '../authConfig';
const FAST = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/fastAuth`,
  scopes: ExtHubRequest,
});

FAST.createEntities([{ name: 'loginFastEapp' }, { name: 'checkAgentValidation' }]);

const LoginFastEapp = () => FAST.endpoints.loginFastEapp.post();
const CheckAgentValidation = (body) => FAST.endpoints.checkAgentValidation.post(body);

export { LoginFastEapp, CheckAgentValidation };
